import React, { Suspense } from 'react';
import * as Sentry from '@sentry/react';
import { loadRemote } from '@module-federation/runtime';
import FullPageLoadingSplash from '@acorn-portal/shared/src/components/loading/FullPageLoadingSplash';

const PayNowApp = React.lazy(() =>
	loadRemote('paynowRemote/PayNowApp').then((m) => {
		if (!m) throw new Error('Failed to load paynowRemote/PayNowApp');
		return m as { default: React.ComponentType };
	}),
);

const ErrorFallback: React.FC<{ onRetry: () => void }> = ({ onRetry }) => (
	<div style={{ padding: '2rem', textAlign: 'center' }} role='alert'>
		<h2>Something went wrong</h2>
		<p>This section is temporarily unavailable. Please try again.</p>
		<button onClick={onRetry} style={{ marginTop: '1rem', padding: '0.5rem 1rem', cursor: 'pointer' }}>
			Retry
		</button>
		<p style={{ marginTop: '1rem' }}>
			<a href='/portal/home'>Go back to policies</a>
		</p>
	</div>
);

/** Loads the authorized pay-now family (`/pay-now/*`) from the paynowRemote plugin. */
const PayNowGateway: React.FC = () => {
	const handleRetry = () => globalThis.location.reload();

	return (
		<Sentry.ErrorBoundary
			fallback={<ErrorFallback onRetry={handleRetry} />}
			beforeCapture={(scope) => {
				scope.setTag('product', 'paynow');
				scope.setTag('module_federation', 'true');
				scope.setContext('paynow_remote', {
					remoteEntry: import.meta.env.VITE_PAYNOW_REMOTE_URL,
					exposedModule: './PayNowApp',
				});
			}}
		>
			<Suspense fallback={<FullPageLoadingSplash message='Loading...' loading />}>
				<PayNowApp />
			</Suspense>
		</Sentry.ErrorBoundary>
	);
};

export default PayNowGateway;
